import AOS from 'aos';
import $ from 'jquery';
import 'jquery.cookie';
import Alpine from "alpinejs";
import intersect from '@alpinejs/intersect'


import '@/entrypoints/scripts/sections/lazyloading.js';
import '@/entrypoints/scripts/sections/main-product.js'; // ???
import '@/entrypoints/scripts/sections/product-info-v2.js'; // ???
import '@/entrypoints/scripts/sections/mobile-menu.js'; // ???
import '@/entrypoints/scripts/sections/video.js'; // to many
import '@/entrypoints/scripts/sections/sticky-header.js'; // ???
import '@/entrypoints/scripts/sections/scroll-to.js'; // ???
import '@/entrypoints/scripts/sections/transition.js';
import '@/entrypoints/scripts/sections/related-articles.js';
import '@/entrypoints/scripts/sections/accessibility.js';
import '@/entrypoints/scripts/components/benefit-accordion.js';
import '@/entrypoints/scripts/components/product-form-new.js'
import '@/entrypoints/scripts/components/dynamic-bundle.js'

window.AOS = AOS;
window.jQuery = $;
window.$ = $;

document.getElementById('cart-icon-bubble')?.addEventListener('click', () => {
    document.body.classList.add('fixed-body', 'chathide');
});

document.querySelectorAll('.close-side-cart').forEach(button => {
    button.addEventListener('click', () => {
        document.body.classList.remove('fixed-body', 'chathide');
    });
});

document.addEventListener('DOMContentLoaded', function () {
    setTimeout(() => {
        const yotpo = window.yotpo;

        if (typeof yotpo === "undefined") {
            return;
        }

        const refreshWidgets = yotpo.refreshWidgets;
        if (!refreshWidgets) {
            return;
        }

        if (typeof yotpo.refreshWidgets !== "function") {
            return;
        }

        refreshWidgets();
    }, 500);
});

// $('.accordion-faq').on('click', '.accordion-header', function () {
//     $(this).toggleClass('active').next().slideToggle();
//
//     $('.tabswrap.mob').addClass('hidefooternav');
//     var activeElements = $('.accordion-header.active');
//
//     if (activeElements.length === 0) {
//         $('.tabswrap.mob').removeClass('hidefooternav');
//     }
// });

document.addEventListener('DOMContentLoaded',  () => {
    const accordions = document.querySelectorAll('.accordion-faq');
    if (!accordions) {
        return;
    }

    if (!accordions?.length) {
        return;
    }

    accordions.addEventListener('click', (event) => {
        const header = event?.target?.closest('.accordion-header');
        if (!header) {
            return;
        }

        if (!header?.contains(header)) {
            return;
        }

        header.classList.toggle('active');

        const tabs = document.querySelectorAll('.tabswrap.mob');
        if (!tabs) {
            return;
        }

        if (!tabs?.length) {
            return;
        }

        tabs?.forEach(tab => {
            tab?.classList?.add('hidefooternav');
        });
    });
});

import bundleBuilder from "./sections/bundle-builder.js";
import addToCart from "./components/add-to-cart.js";
import blogFilter from "./sections/blog-filters.js";
import productStats from "./sections/productStats.js";
import transition from "./sections/transition.js";
import benefitAccordion from "./components/benefit-accordion.js";
import productFormNew from "./components/product-form-new.js";
import parallax from "./components/parallax.js";
import quantityInputNew from "./components/quantity-input-new.js";
import dynamicBundle from "./components/dynamic-bundle.js";

bundleBuilder(Alpine);
addToCart(Alpine);
blogFilter(Alpine);
productStats(Alpine);
transition(Alpine);
benefitAccordion(Alpine);
productFormNew(Alpine);
parallax(Alpine);
quantityInputNew(Alpine);
dynamicBundle(Alpine);

Alpine.plugin(intersect);


window.Alpine = Alpine;
Alpine.start(); 

